import moment from 'moment';
export var state = {
  search: {
    project: {},
    member: {},
    team_member: {},
    team: {}
  }
};